import { render, staticRenderFns } from "./importXls.vue?vue&type=template&id=1e224b0a&scoped=true"
import script from "./importXls.vue?vue&type=script&lang=js"
export * from "./importXls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e224b0a",
  null
  
)

export default component.exports